import { render, staticRenderFns } from "./AdvancedTable.vue?vue&type=template&id=4f88282d&scoped=true&"
import script from "./AdvancedTable.vue?vue&type=script&lang=js&"
export * from "./AdvancedTable.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedTable.vue?vue&type=style&index=0&id=4f88282d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88282d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VIcon,VPagination})
